import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import get from 'lodash/get';
import { CommissionStatusCodes } from '../../../../types/commissions';
const commissionShopThumbAdapter = (props)=>{
    const status = get(props, 'deviation.commission.status');
    const price = get(props, 'deviation.commission.pointsCost');
    const textContent = get(props, 'deviation.textContent', get(props, 'deviation.commission.textContent'));
    const disabled = status !== CommissionStatusCodes.STATUS_ACTIVE;
    const dollarsCost = `$${get(props, 'deviation.commission.dollarsCost')}`;
    return _object_spread_props(_object_spread({}, props), {
        textContent,
        disabled,
        disabledLabel: 'deviationview.commission.commissionClosed',
        price,
        priceLabel: 'shop.thumb.points',
        dollarsCost
    });
};
export default commissionShopThumbAdapter;

//# sourceMappingURL=commission.js.map